interface Leads {
    [formId: string]: unknown;
}

interface NotificationData {
    notification: {
        leads: Leads;
    };
}

interface LeadArray {
    [formId: string]: string[];
}

interface NotificationLeadsData {
    notification: {
        leads: LeadArray;
    };
}

export const storeNotification = (leads_form_id: string, lead_id: string): void => {
  try {
    const storedData: NotificationLeadsData = JSON.parse(localStorage.getItem("notifications") || '{}') || {
      notification: { leads: {} },
    };
    if (!storedData.notification) storedData.notification = { leads: {} };
    if (!storedData.notification.leads) storedData.notification.leads = {};
    if (!storedData.notification.leads[leads_form_id]) {
      storedData.notification.leads[leads_form_id] = [lead_id];
    } else if (!storedData.notification.leads[leads_form_id].includes(lead_id)) {
      storedData.notification.leads[leads_form_id].push(lead_id);
    }
    localStorage.setItem("notifications", JSON.stringify(storedData));
    window.dispatchEvent(new Event("notifications-updated"));
  } catch (error) {
    console.error("❌ Error storing notification:", error);
  }
};


export const removeFormLeadsFromLocalStorage = (leads_form_id: string): void => {
    try {
        const raw = localStorage.getItem('notifications');
        const storedData: NotificationData = raw ? JSON.parse(raw) : { notification: { leads: {} } };

        if (storedData.notification?.leads?.[leads_form_id]) {
            delete storedData.notification.leads[leads_form_id];

            if (Object.keys(storedData.notification.leads).length === 0) {
                storedData.notification.leads = {};
            }
            localStorage.setItem('notifications', JSON.stringify(storedData));
            window.dispatchEvent(new Event('notifications-updated'));
            console.log(`Removed leads for form_id ${leads_form_id}`);
        }
    } catch (error) {
        console.error('Error removing form leads from localStorage:', error);
    }
};

export const clearAllLeadsFromLocalStorage = () => {
  localStorage.setItem('notifications', JSON.stringify({ notification: { leads: {} } }));
  window.dispatchEvent(new Event('notifications-updated'));
};
